import { createStore } from "vuex";

export default createStore({
  state: () => ({
    user: {
      roles: [],
    },
    token: "",
    map: null,
    currentMarker: null,
  }),
  getters: {},
  mutations: {},
  actions: {},
  modules: {},
});
